import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../_config/restapis';
import { map } from 'rxjs/operators';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class APIIPRegisterService {

    constructor(
        private http: HttpClient,
        private db: $DBManagerService,
        private evt: $BroadcastManagerService
    ) { }


    public getBulkConsentSummary(entityId): Observable<any> {
        return this.http.get(APIConstants.GETBULKCONSENTSUMMARY + '/' + entityId);

    }

    public downloadConsentFile(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADCONSENTFILE, data, { responseType: "blob" });

    }
    public getConsentSummaryFilter(data): Observable<any> {
        console.log("data ", data);
        return this.http.post(APIConstants.GETCONSENTSUMMARYFILTER, data);

    }


    public GetQueryTemplateId(data): Observable<any> {
        return this.http.get(APIConstants.GETQUERYTEMPLATEIDS + '/' + data);
    }

    //BulkConsentUpload
    public bulkConsentUpload(data: any): Observable<any> {
        console.log("serive file ------------- ", data);
        return this.http.post(APIConstants.BULKCONSENTUPLOAD, data);
    }

    //EntityID
    //public GetEntityId(entityId(): Observable<any>	{


    public GetEntityId(entityId): Observable<any> {
        console.log(APIConstants.GETENTITYID + '/' + entityId);
        return this.http.get(APIConstants.GETENTITYID + '/' + entityId);
    }

    //EntityName
    public GetEntityName(entityName): Observable<any> {
        console.log(APIConstants.GETENTITYNAME + '/' + entityName);
        return this.http.get(APIConstants.GETENTITYNAME + '/' + entityName);
    }

    public addNewIP(data): Observable<any> {
        return this.http.post(APIConstants.ADDNEWIP, data);
    }
    public listIPAddress(data): Observable<any> {
        return this.http.post(APIConstants.LISTIPADDRESS, data);
    }
    public exportCSV(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADEXCEL, data, { responseType: "blob" });
    }
    public removeIP(data): Observable<any> {
        return this.http.post(APIConstants.REMOVEIP, data);
    }
    public getPaymentInfo(entityID, pageNo, pageSize): Observable<any> {
       // return this.http.get(APIConstants.PAYMENTDUES + '/' + entityID + '/' + pageNo + '/' + pageSize);
        return this.http.get(APIConstants.PAYMENTDUES + '?EntityID=' + entityID + '&pageNo=' + pageNo + '&pageSize=' + pageSize);
    }

    public exportpaymentDuesCSV(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADPAYMENTDUESEXCEL,data,{responseType: "blob"});
    }

    public exportPaymentHistoryCSV(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADPAYMENTHISTORYEXCEL, data, { responseType: "blob" });
    }
    
	 public exportpaymentDuesSearchCSV(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADPAYMENTDUESEXCEL, data, { responseType: "blob" });
    }
	public exportPaymentHistorySearchCSV(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADPAYMENTHISTORYSEARCHEXCEL, data, { responseType: "blob" });
    }
    public addNewURL(data): Observable<any> {
        return this.http.post(APIConstants.ADDNEWURL, data);
    }

    public updatedURL(data): Observable<any> {
        return this.http.post(APIConstants.UPDATEDURL, data);
    }

    public getEntityDetails(urn): Observable<any> {
        return this.http.get(APIConstants.GETENTITYDETAILSURN + '/' + urn);
    }
	
    //pradnya key based authentication
    public generateTokenForEntity(data): Observable<any> {
        return this.http.post(APIConstants.GENERATETOKEN, data);
    }

}
